// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
  overflow: hidden;
}

.header-row {
  font-style: bold;
}

td {
  overflow: hidden;
  width: 100px;
  font-size: 10pt;
  white-space: nowrap;
}

th {
  font-size: 10pt;
  width: 100px;
}

.table-container {
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;
}
.table-container::-webkit-scrollbar {
  height: 8px;
}
.table-container::-webkit-scrollbar-track {
  background: transparent;
}
.table-container::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7);
  border-radius: 4px;
}
.table-container::-webkit-scrollbar-thumb:hover {
  background: rgba(155, 155, 155, 0.9);
}

table {
  width: 100%;
}

.run-info {
  padding: 10px;
  font-size: 13px;
}

textarea {
  display: block;
  width: 95%;
  height: 300px;
}

.rank-0 {
  background-color: rgba(255, 255, 0, 0.1);
}

.rank-1 {
  background-color: rgba(255, 255, 0, 0.06);
}

.compact {
  height: 38px !important;
}

.header {
  cursor: move;
}

.selected {
  background-color: #f2f2f2;
}

.mat-mdc-row .mat-mdc-cell {
  cursor: pointer;
}

.tags-list {
  width: 100%;
}

.vault-link {
  color: blue;
  text-decoration: none;
}

.vault-link:hover {
  text-decoration: underline;
}

.hidden-paginator {
  visibility: hidden;
}

mat-chip-grid {
  margin-top: -10px;
}
mat-chip-grid input {
  color: inherit;
}

mat-progress-bar {
  margin-top: 10px;
  margin-bottom: 10px;
}

.header mat-icon {
  margin-top: -5px;
}

.status-icon {
  min-width: 23px;
}

.state-icon {
  cursor: pointer;
  display: inline-block;
}
.state-icon .state-hover {
  display: none;
}
.state-icon:hover .state-default {
  display: none;
}
.state-icon:hover .state-hover {
  display: inline-block;
}
.state-icon.running:hover .state-hover {
  color: #d32f2f;
}

.edit-description {
  margin-top: -4px;
  border: none;
  border-bottom: 1px solid hsl(0, 3%, 79%);
}

.edit-description:focus {
  margin-top: -4px;
  border: none;
  border-bottom: 1px solid hsl(0, 3%, 79%);
}

.edit-description:focus-visible {
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/models/perf-table/perf-table.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;AACF;;AAGA;EACE,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qDAAA;AAAF;AAEE;EACE,WAAA;AAAJ;AAGE;EACE,uBAAA;AADJ;AAIE;EACE,oCAAA;EACA,kBAAA;AAFJ;AAII;EACE,oCAAA;AAFN;;AAOA;EACE,WAAA;AAJF;;AAOA;EAEE,aAAA;EACA,eAAA;AALF;;AAQA;EACE,cAAA;EACA,UAAA;EACA,aAAA;AALF;;AAQA;EACE,wCAAA;AALF;;AAQA;EACE,yCAAA;AALF;;AAQA;EACE,uBAAA;AALF;;AAQA;EACE,YAAA;AALF;;AAQA;EACE,yBAAA;AALF;;AAQA;EACE,eAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAQA;EACE,WAAA;EACA,qBAAA;AALF;;AAQA;EACE,0BAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,iBAAA;AALF;AAOE;EACE,cAAA;AALJ;;AASA;EACE,gBAAA;EACA,mBAAA;AANF;;AASA;EACE,gBAAA;AANF;;AASA;EACE,eAAA;AANF;;AASA;EACE,eAAA;EACA,qBAAA;AANF;AAQE;EACE,aAAA;AANJ;AAUI;EACE,aAAA;AARN;AAUI;EACE,qBAAA;AARN;AAYE;EACE,cAAA;AAVJ;;AAcA;EACI,gBAAA;EACA,YAAA;EACA,wCAAA;AAXJ;;AAcA;EACE,gBAAA;EACA,YAAA;EACA,wCAAA;AAXF;;AAcA;EACE,aAAA;AAXF","sourcesContent":[":host {\n  display: block;\n  height: 100%;\n  overflow: hidden;\n}\n\n.header-row {\n  font-style: bold;\n}\n\ntd {\n  overflow: hidden;\n  width: 100px;\n  font-size: 10pt;\n  white-space: nowrap;\n}\n\nth {\n  font-size: 10pt;\n  width: 100px;\n}\n\n\n.table-container {\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;\n\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(155, 155, 155, 0.7);\n    border-radius: 4px;\n\n    &:hover {\n      background: rgba(155, 155, 155, 0.9);\n    }\n  }\n}\n\ntable {\n  width: 100%;\n}\n\n.run-info {\n  //padding: var(--content-margin) var(--content-margin) 0;\n  padding: 10px;\n  font-size: 13px;\n}\n\ntextarea {\n  display: block;\n  width: 95%;\n  height: 300px;\n}\n\n.rank-0 {\n  background-color: rgba(255, 255, 0, 0.1);\n}\n\n.rank-1 {\n  background-color: rgba(255, 255, 0, 0.06);\n}\n\n.compact {\n  height: 38px !important;\n}\n\n.header {\n  cursor: move;\n}\n\n.selected {\n  background-color: #f2f2f2;\n}\n\n.mat-mdc-row .mat-mdc-cell {\n  cursor: pointer;\n}\n\n.tags-list {\n  width: 100%;\n}\n\n.vault-link {\n  color: blue;\n  text-decoration: none;\n}\n\n.vault-link:hover {\n  text-decoration: underline;\n}\n\n.hidden-paginator {\n  visibility: hidden;\n}\n\nmat-chip-grid {\n  margin-top: -10px;\n\n  input {\n    color: inherit;\n  }\n}\n\nmat-progress-bar {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.header mat-icon {\n  margin-top: -5px;\n}\n\n.status-icon {\n  min-width: 23px;\n}\n\n.state-icon {\n  cursor: pointer;\n  display: inline-block;\n\n  .state-hover {\n    display: none;\n  }\n\n  &:hover {\n    .state-default {\n      display: none;\n    }\n    .state-hover {\n      display: inline-block;\n    }\n  }\n\n  &.running:hover .state-hover {\n    color: #d32f2f;\n  }\n}\n\n.edit-description {\n    margin-top: -4px;\n    border: none;\n    border-bottom: 1px solid hsl(0, 3%, 79%);\n}\n\n.edit-description:focus {\n  margin-top: -4px;\n  border: none;\n  border-bottom: 1px solid hsl(0, 3%, 79%);\n}\n\n.edit-description:focus-visible {\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
